/**
 * LM Mobile · More menu
 * Quick access to the admin pages that aren't on the bottom nav.
 * Tapping any item takes the LM into the full admin shell (with sidebar).
 */
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  ClipboardList,
  Wrench,
  ShieldCheck,
  MapPin,
  Truck,
  PackageOpen,
  ArrowRight,
  LogOut,
  Monitor,
} from "lucide-react";

const ITEMS = [
  { label: "Logistics Hub (Trips / FASTag / Imprest)", to: "/logistics/hub", icon: ClipboardList, tone: "indigo" },
  { label: "Vehicle Ops (Maintenance / Challans / Inspections)", to: "/logistics/vehicle-ops", icon: Wrench, tone: "emerald" },
  { label: "Fleet Compliance (Docs / Expiry)", to: "/logistics/fleet-compliance", icon: ShieldCheck, tone: "rose" },
  { label: "FASTag Map", to: "/logistics/fastag-map", icon: MapPin, tone: "sky" },
  { label: "Driver Attendance", to: "/logistics/driver-attendance", icon: Truck, tone: "amber" },
  { label: "Fuel & Mileage", to: "/logistics/fuel", icon: PackageOpen, tone: "violet" },
  { label: "Open full Desktop View", to: "/", icon: Monitor, tone: "slate" },
];

const TONES = {
  indigo: "bg-indigo-50 text-indigo-900 ring-indigo-200",
  emerald: "bg-emerald-50 text-emerald-900 ring-emerald-200",
  rose: "bg-red-50 text-red-900 ring-red-200",
  sky: "bg-sky-50 text-sky-900 ring-sky-200",
  amber: "bg-amber-50 text-amber-900 ring-amber-200",
  violet: "bg-violet-50 text-violet-900 ring-violet-200",
  slate: "bg-slate-100 text-slate-900 ring-slate-300",
};

export default function LMMore() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="space-y-3" data-testid="lm-more">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
          LM · More
        </div>
        <h1 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Chivo" }}>
          Other Tools
        </h1>
        <p className="text-[11px] text-slate-500 mt-0.5">
          Signed in as <strong>{user?.name}</strong> · {user?.email}
        </p>
      </div>

      <div className="space-y-2">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          return (
            <button
              key={it.to}
              onClick={() => navigate(it.to)}
              data-testid={`lm-more-${it.to.replace(/\//g, "-")}`}
              className={`w-full flex items-center gap-3 p-3 rounded-xl ring-1 transition hover:opacity-90 ${TONES[it.tone]}`}
            >
              <div className="h-9 w-9 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
                <Icon className="h-5 w-5" />
              </div>
              <div className="flex-1 text-left text-sm font-semibold">{it.label}</div>
              <ArrowRight className="h-4 w-4 opacity-60" />
            </button>
          );
        })}
      </div>

      <button
        onClick={async () => { await logout(); navigate("/login"); }}
        data-testid="lm-more-logout"
        className="w-full mt-4 flex items-center justify-center gap-2 py-3 rounded-xl ring-1 ring-slate-300 bg-white text-slate-700 font-semibold"
      >
        <LogOut className="h-4 w-4" /> Logout
      </button>
    </div>
  );
}
